import { Dispatch } from 'redux';
import { getIssuers } from '../../services/issuer.service';
import { CustomErrorResponse } from '../../types/customError/response';
import { Issuer } from '../../types/issuer/response';
import { ADD_ISSUERS, IssuersTypes, ISSUERS_ERROR, LOADING_ISSUERS } from '../config/ActionTypes';

const isGetIssuers = (object: Issuer[] | CustomErrorResponse): boolean => {
  return !('errorCode' in object);
};

export const fetchIssuers = () => {
  return (dispatch: Dispatch<IssuersTypes>) => {
    dispatch(loadingIssuers());

    return getIssuers().then(
      (response) => {
        if (isGetIssuers(response)) {
          const issuers = response as Issuer[];
          dispatch(addIssuers(issuers));
        }
      },
      (error) => {
        dispatch(issuersFailed(error));
      },
    );
  };
};

export const loadingIssuers = (): IssuersTypes => ({
  type: LOADING_ISSUERS,
});

export const addIssuers = (issuers: Issuer[]): IssuersTypes => ({
  type: ADD_ISSUERS,
  issuers,
});

export const issuersFailed = (error: string): IssuersTypes => ({
  type: ISSUERS_ERROR,
  error,
});
